module.exports = __webpack_public_path__ + "static/media/CBNImg3.0b706caa.webp";